<template>
  <form class="form" autocomplete="off" @submit.prevent="submit">
    <h2>{{ $t('editExam.TITLE') }}</h2>
    <BaseInput
      :label="$t(`baseExamForm.label.NAME`)"
      :placeholder="$t('baseExamForm.NAME_PLACEHOLDER')"
      v-model="exam.name"
      type="text"/>
    <label>{{ $t(`baseExamForm.label.START`) }}
      <date-picker v-model="exam.start"/>
    </label>
    <label>{{ $t(`baseExamForm.label.END`) }}
      <date-picker v-model="exam.end"/>
    </label>
    <BaseInput
      :label="$t('baseExamForm.label.TIMING')"
      :placeholder="$t('baseExamForm.TIMING_PLACEHOLDER')"
      type="number"
      v-model="exam.timing"
      min="0"
      max="2147483647"
    />
    <label>{{ $t('baseExamForm.label.PROCTORING') }}
      <multiselect
        v-model="exam.proctoring"
        :searchable="false"
        :selectLabel="$t('selectExam.label.SELECT')"
        :deselectLabel="$t('selectExam.label.DESELECT')"
        :customLabel="getProctoringLabel"
        :options="proctoringOptions"
        :placeholder="$t('baseExamForm.PROCTORING_PLACEHOLDER')"
      />
    </label>
    <label>{{ $t(`baseExamForm.label.COMMISSION`) }}
      <select-members
        v-model="exam.commission_members"
        :options="commission"/>
    </label>
    <file-upload-button
      class="file-upload-container"
      v-model="papersFile"
      :buttonText="$t(`baseExamForm.UPLOAD_BUTTON`)"
      :helpText="$t(`baseExamForm.UPLOAD_HELP`)"/>
    <div v-if="errors.length" class="errors-container">
      <ul>
        <li class="error" v-for="error in errors" :key="error">{{ error }}</li>
      </ul>
    </div>
    <div class="submit-container">
      <input class="primary-button" type="submit" :value="$t('editExam.SUBMIT_BUTTON')">
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import exam from '@/mixins/exam'

export default {
  name: 'EditExam',
  mixins: [exam],
  props: {
    id: [String, Number]
  },
  data () {
    return {
      exam: {},
      prefix: 'editExam'
    }
  },
  created () {
    this.$loading.start()

    Promise.all([
      this.getExamInfo(),
      ...this.getExaminers()
    ])
      .catch(() => this.$loading.fail())
      .finally(() => this.$loading.done())
  },
  methods: {
    afterProcessed (examData, papers) {
      const examId = this.id
      const editExamPromise = this.editExam({ examId, exam: examData })

      this.$awn.async(
        editExamPromise,
        exam => this.onExamSuccess(exam, papers),
        this.onExamFailure,
        this.$t('editExam.awn.SEND_FORM')
      )
    },
    onExamSuccess (exam, papers) {
      this.$awn.success(this.$t('editExam.awn.EXAM_SUCCESS'))
      if (papers) {
        this.sendPapers(exam, papers)
      } else this.$router.push({ name: 'Exams' })
    },
    onExamFailure () {
      this.$awn.alert(this.$t('editExam.awn.EXAM_FAILURE'))
    },
    onPapersSuccess () {
      this.$awn.success(this.$t('editExam.awn.PAPERS_SUCCESS'))
      this.$router.push({ name: 'Exams' })
    },
    onPapersFailure () {
      this.$awn.alert(this.$t('editExam.awn.PAPERS_FAILURE'))
    },
    getExamInfo () {
      return this.fetchExam(this.id)
        .then(exam => {
          this.exam = exam
          return this.fetchExamCommission(this.id)
        })
        .then(commission => {
          this.$set(this.exam, 'commission_members', commission)
        })
    },
    getExaminers () {
      const promises = []

      this.user.companies.forEach(companyId => {
        promises.push(
          this.fetchCompanyUsers(companyId)
            .then(users => this.commission.push(...users))
        )
      })

      return promises
    },
    ...mapActions([
      'fetchExam',
      'fetchCompanyUsers',
      'fetchExamCommission',
      'editExam',
      'uploadPapers'
    ])
  },
  computed: mapState(['user'])
}
</script>

<style lang="scss" scoped>
@import "~@/styles/base.scss";

</style>
